import React from "react";
import { DeviceStatus } from "@app/shared/src/models";

const STALE_MS = 15 * 60 * 1000;

/** Health at a glance, in front of a device's name — green healthy, amber degraded, grey silent. */
export const StatusDot: React.FC<{ status?: DeviceStatus; lastHeartbeat?: Date | string }> = ({ status, lastHeartbeat }) => {
    const age = lastHeartbeat ? Date.now() - new Date(lastHeartbeat).getTime() : Infinity;
    const colour =
        age > STALE_MS ? "var(--faint)" : status === DeviceStatus.Healthy ? "var(--safe)" : "var(--warn)";
    return (
        <span
            className="inline-block h-[11px] w-[11px] flex-none rounded-full"
            style={{ background: colour, boxShadow: `0 0 0 4px color-mix(in srgb, ${colour} 22%, transparent)` }}
            aria-hidden
        />
    );
};
